<template>
  <div>
    <header id="header">
      <!--/.top-bar-->
      <nav class="navbar navbar-expand-lg navbar-dark">
        <div class="container-xl">
          <div class="navbar-brand"><a href="/">1Click 商聯快通</a></div>

          <!--m_menu-->
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample07XL" aria-controls="navbarsExample07XL" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <!--end m_menu-->

          <div class="collapse navbar-collapse" id="navbarsExample07XL">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item">
                <a class="nav-link" href="mailto:info@yscreatech.com">聯絡揚揚</a>
              </li>
            </ul>
          </div>

        </div>
      </nav>
      <!--/nav-->

    </header>
    <!--/header-->

    <section id="main-slider" class="no-margin">
      <div class="carousel slide">
        <div class="carousel-inner">
          <div class="item active" style="background-image: url(images/slides.jpg)">
            <div class="container">
              <div class="row">
                <div class="col-md-7">
                  <div class="carousel-content">
                    <h1 class="animation animated-item-1">
                      1Click-Speed business connection<br>商聯快通智慧服務<br>品牌資料即掃即得
                    </h1>
                    <div class="animation animated-item-2">
                      友善與智慧兼具的商務資訊快遞服務
                    </div>
                    <a class="btn-slide animation animated-item-3" href="mailto:info@yscreatech.com">瞭解更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--/.item-->
        </div>
        <!--/.carousel-inner-->
      </div>
      <!--/.carousel-->
    </section>
    <!--/#main-slider-->
    <section id="steps" class="service-item">
      <div class="container">
        <div class="center fadeInDown">
          <h2>四步驟啟用1Click </h2>
          <p class="lead">迅速商務資訊交換 自動化處理省時又省力</p>
        </div>

        <div class="box row justify-content-between mx-5">
          <div class="boxSideText">使<br>用<br>步<br>驟</div>

          <div class="item"><div class="title">掃描展覽<br>QrCode</div><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#ffffff" class="bi bi-upc-scan" viewBox="0 0 16 16">
            <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"/>
          </svg></div>
          <div class="item"><div class="title">按下連結<br>打開瀏覽器</div><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#ffffff" class="bi bi-window" viewBox="0 0 16 16">
            <path d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
            <path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm13 2v2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zM2 14a1 1 0 0 1-1-1V6h14v7a1 1 0 0 1-1 1H2z"/>
          </svg></div>
          <div class="item"><div class="title">填寫資料<br>(初次入場須填)</div><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#ffffff" class="bi bi-file-earmark-text" viewBox="0 0 16 16">
            <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>
            <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
          </svg></div>
          <div class="item"><div class="title">快速完成<br>商務資料索取</div><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#ffffff" class="bi bi-check2-square" viewBox="0 0 16 16">
            <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"/>
            <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
          </svg></div>
          <div class="item"><div class="title">收取品牌<br>資料</div><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#ffffff" class="bi bi-envelope" viewBox="0 0 16 16">
            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
          </svg></div>
        </div>
        <!--/.row-->
      </div>
      <!--/.container-->
    </section>

    <section id="services" class="service-item">
      <div class="container">
        <div class="center fadeInDown">
          <h2>六大好處</h2>
          <p class="lead">自動彙整資訊 讓展後資訊整理省時又省力</p>
        </div>

        <div class="row">

          <div class="col-sm-6 col-md-4">
            <div class="media services-wrap fadeInDown">
              <div class="pull-left">
                <img class="img-responsive" src="images/content_paste_black_48dp.svg">
              </div>
              <div class="media-body">
                <h3 class="media-heading">同會場不需重複填寫資料</h3>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="media services-wrap fadeInDown">
              <div class="pull-left">
                <img class="img-responsive" src="images/crop_free_black_48dp.svg">
              </div>
              <div class="media-body">
                <h3 class="media-heading">一掃即得品牌資訊</h3>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="media services-wrap fadeInDown">
              <div class="pull-left">
                <img class="img-responsive" src="images/signal_cellular_no_sim_black_48dp.svg">
              </div>
              <div class="media-body">
                <h3 class="media-heading">無紙化遞送品牌資訊</h3>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="media services-wrap fadeInDown">
              <div class="pull-left">
                <img class="img-responsive" src="images/mark_as_unread_black_48dp.svg">
              </div>
              <div class="media-body">
                <h3 class="media-heading">自動彙整並Email參訪清單</h3>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="media services-wrap fadeInDown">
              <div class="pull-left">
                <img class="img-responsive" src="images/tap_and_play_black_48dp.svg">
              </div>
              <div class="media-body">
                <h3 class="media-heading">安全無接觸式商務資訊交換</h3>

              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="media services-wrap fadeInDown">
              <div class="pull-left">
                <img class="img-responsive" src="images/do_not_touch_black_48dp.svg">
              </div>
              <div class="media-body">
                <h3 class="media-heading">毋需人工整理參訪資料</h3>
              </div>
            </div>
          </div>

        </div>
        <!--/.row-->
      </div>
      <!--/.container-->
    </section>
    <!--/#services-->

    <section id="testimonial">
      <div class="container">
        <div class="center fadeInDown">
          <h2>簡單操作</h2>
          <p class="lead">迅速完成商務資訊交換，品牌資訊蒐集<br>當日展出結束後三小時，自動Email參訪清單與相關資訊給參訪者與品牌雙方。</p>
        </div>
        <div class="testimonial-slider owl-carousel">
          <div class="single-slide">
            <div class="content">
              <img src="images/p1.png" alt="">
              <p>參展品牌填寫品牌資料，方便快速</p>
            </div>
          </div>
          <div class="single-slide">
            <div class="content">
              <img src="images/p5.png" alt="">
              <p>免費生成可列印公告</p>
            </div>
          </div>
          <div class="single-slide">
            <div class="content">
              <img src="images/p2.png" alt="">
              <p>同一會展參觀者只需填寫一次個人資料</p>
            </div>
          </div>
          <div class="single-slide">
            <div class="content">
              <img src="images/p3.png" alt="">
              <p>自動辨識與帶入個人資料，不需再次填寫</p>
            </div>
          </div>
          <div class="single-slide">
            <div class="content">
              <img src="images/p4.png" alt="">
              <p>完成無紙化商聯快通智慧服務，可點選下方電子型錄連結，觀看品牌資訊。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer id="footer" class="midnight-blue">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">&copy; 2014-2021 Young Square Createch LTD.</div>
        </div>
      </div>
    </footer>
    <!--/#footer-->
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
